class Accordion {
  constructor(element) {
    this.element = element;
    this.init();
  }

  getElement() {
    return this.element;
  }


  setEvents() {
    let forgotPass = document.querySelector('#RecoverPassword');
    let recoverForm = document.querySelector('#RecoverPasswordForm');
    let recoverEmail = document.querySelector('#RecoverEmailSend');
    let loginForm = document.querySelector('#CustomerLoginForm');  
    let createAccount = document.querySelector('#createAccount');
    let terms = document.querySelector('#accept-terms');
    let singin = document.querySelector('#signin-form');
    let skip = document.querySelector('#skip-account');
    let save = document.querySelector('#save-account');
    let resetPass = document.querySelector('#ResetPasswordBtn');
    let password = document.querySelector('#CustomerPassword');
    let email = document.querySelector('#CustomerEmail');
  

    if(!!resetPass) {
      resetPass.addEventListener('click', (event) => {     
        let success = this.validateResetPassword();

        if(!!success) {
          document.querySelector('#reset_pass').submit()
        }

      });
    }

    if(!!recoverEmail) {
      recoverEmail.addEventListener('click', (event) => {
        let email = document.querySelector('#RecoverEmail');
        let spanEmail = document.querySelector('#error-email-pass');
        let regex = new RegExp('[a-z0-9]+@[a-z]+\.[a-z]{2,3}');
        let success = true;
       
        if(email.value  === '') {
          spanEmail.innerHTML = 'Please enter the email.';
          email.classList.add('error');
          success = false;

        }else if(!regex.test( email.value)){
          spanEmail.innerHTML = 'Please add a valid email';
          email.classList.add('error');
          success = false;

        } else {
          email.classList.remove('error');     
          success = true;
        }

        if(!!success){
          document.querySelector('#recover-password-form form').submit()
        }
      })
    }

    if(!!terms){
      terms.addEventListener('click' , () => {
        // accepting terms and conditions
        if(!terms.checked){
          createAccount.classList.add('disabled');
        }else {
          createAccount.classList.remove('disabled');
        }
      });
    }
    
    if(!!forgotPass){
      forgotPass.addEventListener('click' , () => {
        if(!!recoverForm)
          recoverForm.classList.remove('hide');
        
        if(!!loginForm)
        loginForm.classList.add('hide');      
      });
    }
    
    if(!!createAccount){
      createAccount.addEventListener('click' , () => {
        let success = this.validateCreateAccount();

        if(success){
          let step0 = document.querySelector('#step-0');
          let step1 = document.querySelector('#step-1');
          let step2 = document.querySelector('#step-2');

          step0.classList.add('hide');
          step1.classList.add('hide');
          step2.classList.remove('hide');
          
        }  
      });
    }

    if(!!skip) {
      skip.addEventListener('click' , (e) => {
        console.log('clicking skip button');
        e.preventDefault(); 
        document.querySelector('#RegisterForm').submit();
      });
    }

    if(!!save) {
      save.addEventListener('click' , (e) => {
        console.log('clicking save button');
        e.preventDefault();
        let success = this.validateLastStep();
        if(success){
          document.querySelector('#RegisterForm').submit();
        }
      });
    }

    if(!!email){
      email.addEventListener('keyup', (event) => {
        if (event.keyCode === 13) {
          console.log('enter key :) ')
          let success = this.validateLogin();

          if(success){
            document.querySelector('#customer_login').submit();
          }
        }

      });
    }
    
    if(!!password){
      password.addEventListener('keyup', (event) => {
        if (event.keyCode === 13) {
          console.log('enter key :) ')
          let success = this.validateLogin();

          if(success){
            document.querySelector('#customer_login').submit();
          }
        }

      });
    }

    if(!!singin){
      singin.addEventListener('click', () => {
        let success = this.validateLogin();

        if(success){
          document.querySelector('#customer_login').submit();
        }
      });
    }

  }

  validateLastStep() {
    let phone  = document.querySelector('#phone-account');
    let errorPhone  = document.querySelector('#error-phone');
    let birthday  = document.querySelector('#birthday-account');
    let check  = document.querySelector('#check__terms');
    let errorCheck  = document.querySelector('#error-birthday-check');
    let result = true;
    

    if(phone.value === ''  || /[a-zA-Z]/.test(phone.value) === true){
      phone.classList.add('error');
      result = false;
    }else {
      phone.classList.remove('error');
    }

    if(birthday.value === ''){
      birthday.classList.add('error');
      result = false;
    }else {
      birthday.classList.remove('error');
    }

    if(!check.checked){
      errorCheck.classList.add('error');
      errorPhone.classList.add('error');
      check.classList.add('error'); 

      result = false;
    }else {
      errorPhone.classList.remove('error');
      errorCheck.classList.remove('error');
      check.classList.remove('error');
    }

    return result;
  }

  validateResetPassword(){
    let password = document.querySelector('#ResetPassword');
    let comfirmPassword = document.querySelector('#PasswordConfirmation');   

    comfirmPassword.classList.remove('error');
    password.classList.remove('error');  
    
    if(password.value === ''){
      password.classList.add('error');
      return false;

    }else if(password.value.length < 5) {
      let spanPass = document.querySelector('#error-password');
      spanPass.innerHTML = 'Password is too short (minimum is 5 characters)';
      password.classList.add('error');
      return false;
      
    }else if(comfirmPassword.value === '' ){
      comfirmPassword.classList.add('error');
      return false;

    }else if(password.value !== comfirmPassword.value){            
      let spanPass = document.querySelector('#error-password');
      spanPass.innerHTML = 'Password does not match.';

      let spanConfirm = document.querySelector('#error-comfirmpass');
      spanConfirm.innerHTML = 'Password does not match.';
      
      password.classList.add('error');
      comfirmPassword.classList.add('error');

      return false;
      
    }else {
      comfirmPassword.classList.remove('error');
      password.classList.remove('error');      
    }

    return true;
  }

  validateLogin(){
    let email = document.querySelector('#CustomerEmail');
    let password = document.querySelector('#CustomerPassword');
    let regex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    let success = true;

    if(email.value  === '') {
      let spanEmail = document.querySelector('#error-email');
      spanEmail.innerHTML = 'Please enter the email.';
      email.classList.add('error');
      success = false;

    }else if(!regex.test( email.value)){
      let spanEmail = document.querySelector('#error-email');
      spanEmail.innerHTML = 'Please add a valid email';
      email.classList.add('error');
      success = false;

    } else {
      email.classList.remove('error');
      success = true;
    }

    if(password.value === ''){
      password.classList.add('error');
      success = false;
    }else {
      password.classList.remove('error');
      success = true;
    }

    return success;
  }

  validateCreateAccount() {
    let name = document.querySelector('#RegisterForm-FirstName');
    let lastName = document.querySelector('#RegisterForm-LastName');
    let email = document.querySelector('#RegisterForm-email');    
    let password = document.querySelector('#RegisterForm-password');
    let comfirmPassword = document.querySelector('#ConfirmPassword');    
    let regex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    let success = true;

    if(name.value === ''){
      name.classList.add('error');
      success = false;
    }else {
      name.classList.remove('error');      
    }
    
    if(email.value  === '') {
      let spanEmail = document.querySelector('#error-email');
      spanEmail.innerHTML = 'Please enter the email.';
      email.classList.add('error');
      success = false;

    }else if(!regex.test( email.value)){
      let spanEmail = document.querySelector('#error-email');
      spanEmail.innerHTML = 'Please add a valid email';
      email.classList.add('error');
      success = false;

    } else {
      email.classList.remove('error');     
    }

    if(comfirmPassword.value === ''){ 
      comfirmPassword.classList.add('error');
      success = false;
    }else{
      comfirmPassword.classList.remove('error');
    }
    
    if(password.value === ''){
      password.classList.add('error');
      success = false;

    }else if(password.value.length < 5) {
      let spanPass = document.querySelector('#error-password');
      spanPass.innerHTML = 'Password is too short (minimum is 5 characters)';
      password.classList.add('error');
      success = false;
      
    }else if(comfirmPassword.value === '' ){
      comfirmPassword.classList.add('error');
      success = false;

    }else if(password.value !== comfirmPassword.value){            
      let spanPass = document.querySelector('#error-password');
      spanPass.innerHTML = 'Password does not match.';

      let spanConfirm = document.querySelector('#error-comfirmpass');
      spanConfirm.innerHTML = 'Password does not match.';
      
      password.classList.add('error');
      comfirmPassword.classList.add('error');

      success = false;
      
    }else {
      email.classList.remove('error');
      comfirmPassword.classList.remove('error');
      password.classList.remove('error');      
    }

    if(lastName.value === ''){
      lastName.classList.add('error');
      success = false;

    }else {
      lastName.classList.remove('error');      
    }
    return success;
  }

  initAccordionAccount(){
    let tabsList = document.querySelectorAll('[data-accordion-account] [data-accordion-title]');  
    let goBack = document.querySelector('#go-back');
    let parentTab = document.querySelector('.customers__info');
    let parentBody = document.querySelector('.customers__details');
    let orderHistory = document.querySelector('[data-orders-details]');
    let windowWidth = window.innerWidth;

    if(!!parentTab && !!parentBody){
      window.addEventListener('resize', function(event) {
        let width = event.currentTarget.innerWidth;
        windowWidth = width; 
        
        if(width > 1024) {
          parentTab.classList.remove('hide');
          parentBody.classList.remove('active');  

        }else {
          if(!!orderHistory){ 
            parentTab.classList.add('hide');
            parentBody.classList.add('active');  
          }
        }

      }, true);
    }

    if(!!goBack){
      goBack.addEventListener("click", (event) => {
        if(windowWidth <= 1024){
          parentTab.classList.remove('hide');
          parentTab.classList.remove('hide_order');
          parentBody.classList.remove('active');
        }
      });
    }

    if(!!tabsList){
      for (let tab of tabsList) {
        tab.addEventListener("click", (event) => {
          let dataId = tab.getAttribute('data-id'); 
          let currentTab = document.querySelector('.customers__form.active');
          let currentLink = document.querySelector('.customers__link.active');
       
          if(!!currentTab)
            currentTab.classList.remove('active');

          if(!!currentLink)
            currentLink.classList.remove('active');

          
          console.log('dataID ', dataId);

          if(dataId == 'order-accordion'){
            let orderHistory = document.querySelector('[data-orders-details]');
            let orderListed = document.querySelector('[data-orders-listed]');
            
            if(!!orderHistory){
              orderHistory.classList.remove('active');
              orderListed.classList.add('active');
              window.history.replaceState("", document.title, window.location.href.replace("orders/", "").replace(/[^\/]+$/, ""));
              document.title = 'Order History';
            }
          }
           
          document.querySelector(`#${dataId}`).classList.add('active');
          document.querySelector(`[data-id="${dataId}"]`).classList.add('active');

          if(windowWidth <= 1024){
            parentTab.classList.add('hide');
            parentBody.classList.add('active');
          }

        })
      }
    }

  }

  maintainAddresses(){
    let customers = document.querySelector('.customers');    
    if(!!customers){
      let editBtns = document.querySelectorAll('[data-open-edit-address]');
      let cancelBtns = document.querySelectorAll('[data-cancel-addresses]');
      let deleteBtns = document.querySelectorAll('[data-delete-address]');
      let comfirmBtns = document.querySelectorAll('[data-comfirm-address]');
      let showNewAddress = document.querySelector('[data-show-new-address]');      
      let cancelNewAddress = document.querySelector('[data-cancel-new-address]');
      let addNewAddress = document.querySelector('[data-add-new-address]');
      let makeDefaultLinks = document.querySelectorAll('[data-make-default-address]');

      if(!!makeDefaultLinks) {

        for (let elem of makeDefaultLinks) {
          elem.addEventListener('click', (event) => {
            let dataId = elem.getAttribute('data-form-id');       
            let inputEdit = document.querySelector(`#address_default_address_${dataId}`);
            let formEdit = document.querySelector(`#address_form_${dataId}`);

            if(!!formEdit && !!inputEdit) {
              inputEdit.checked = true;
              formEdit.submit();
            }
          
          });
        }
      }


      if(!!editBtns){
        for (let elem of editBtns) {
          elem.addEventListener("click", (event) => {
            let dataId = elem.getAttribute('data-form-id'); 
            let wrapper = document.querySelector(`.edit-form__${ dataId }`);

            if(!!wrapper){
              wrapper.classList.remove('hide');
            }

          });
        }
      }

      if(!!cancelBtns){
        for (let elem of cancelBtns) {
          elem.addEventListener("click", (event) => {
            let dataId = elem.getAttribute('data-form-id'); 
            let wrapper = document.querySelector(`.edit-form__${ dataId }`);

            if(!!wrapper){
              wrapper.classList.add('hide');
            }

          });
        }
      }

      if(!!deleteBtns){
        for (let elem of deleteBtns) {
          elem.addEventListener("click", (event) => {
            let dataId = elem.getAttribute('data-form-id'); 
            Shopify.postLink("/account/addresses/" + dataId, {
              parameters: { _method: "delete" },
            });         
          });
        }
      }

      if(!!addNewAddress) {
        addNewAddress.addEventListener("click", (event) => {
          let form = document.querySelector(`#address_form_new`);        
          let success = this.validateAddNewForm();      
          if(!!form && !!success){ 
            form.submit(); // checking because it's not working 
          }

        });
      }

      if(!!comfirmBtns){ // edit addresses
        for (let elem of comfirmBtns) {
          elem.addEventListener("click", (event) => {
            event.preventDefault();

            let dataId = elem.getAttribute('data-form-id'); 
            let form = document.querySelector(`#address_form_${ dataId }`);
            let success = this.validateEditForm(dataId);

            if(!!form && !!success){ 
              form.submit(); // checking because it's not working
            }

          });
        }
      }

      if(!!showNewAddress){
        showNewAddress.addEventListener('click', () => {
          let addForm = document.querySelector('[ data-new-address]');
          if(!!addForm){
            addForm.classList.remove('hide');
          }
        });
      }

      if(!!cancelNewAddress) {
        cancelNewAddress.addEventListener('click', ()=> {
          let addForm = document.querySelector('[ data-new-address]');

          if(!!addForm){
            addForm.classList.add('hide');
          }
        });
      }

    }
    
  }

  validateEditForm(id) {
    let name = document.querySelector(`#AddressFirstName_${id}`);
    let address = document.querySelector(`#AddressAddress1_${id}`);
    let city = document.querySelector(`#AddressCity_${id}`);
    let postal = document.querySelector(`#AddressZip_${id}`);
    let phone = document.querySelector(`#AddressPhone_${id}`);
    let success = true;

    if(name.value === ''){
      name.classList.add('error');
      success = false;
    }else {
      name.classList.remove('error');
      success = true;
    }

    if(address.value === ''){
      address.classList.add('error');
      success = false;
    }else {
      address.classList.remove('error');
      success = true;
    }

    if(city.value === ''){
      city.classList.add('error');
      success = false;
    }else {
      city.classList.remove('error');
      success = true;
    }

    if(postal.value === ''){
      postal.classList.add('error');
      success = false;
    }else {
      postal.classList.remove('error');
      success = true;
    }

    if(phone.value === ''){
      phone.classList.add('error');
      success = false;
    }else {
      phone.classList.remove('error');
      success = true;
    }
    return success;
  }

  validateAddNewForm() {
    let name = document.querySelector(`#AddressFirstNameNew`);
    let address = document.querySelector(`#AddressAddress1New`);
    let city = document.querySelector(`#AddressCityNew`);
    let postal = document.querySelector(`#AddressZipNew`);
    let phone = document.querySelector(`#AddressPhoneNew`);
    let success = true;

    if(name.value === ''){
      name.classList.add('error');
      success = false;
    }else {
      name.classList.remove('error');
      success = true;
    }

    if(address.value === ''){
      address.classList.add('error');
      success = false;
    }else {
      address.classList.remove('error');
      success = true;
    }

    if(city.value === ''){
      city.classList.add('error');
      success = false;
    }else {
      city.classList.remove('error');
      success = true;
    }

    if(postal.value === ''){
      postal.classList.add('error');
      success = false;
    }else {
      postal.classList.remove('error');
      success = true;
    }

    if(phone.value === ''){
      phone.classList.add('error');
      success = false;
    }else {
      phone.classList.remove('error');
      success = true;
    }
    return success;
  }

  init() {
    window.addEventListener('load', (event) => {
      this.setEvents();
      this.initAccordionAccount();
      this.maintainAddresses();    
    });
  }
}

const AccountInit = {
  init() {
    const $el = document.querySelectorAll(".account");
    if ($el.length) {
      for (let $e of $el) {
        new Accordion($e);
      }
    }
  },
};


export default AccountInit;